import request from '@/utils/request'
import store from '../store'
export const uploadUrl =  store.getters.tenantsApi + 'api/fileResouceItem/uploadPic'

export function uploadFile(formFile) {
  return request({
    url: '/api/fileResouceItem/uploadUnified',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}export function uploadImg(formFile) {
  return request({
    url: '/api/fileResouceItem/uploadPic',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}

/**
 *  上传视频接口
 *  后缀只能是MP4
 *  大小在20MB 以内
 */
export function uploadVideo(formFile){

  return request({
    url: '/api/fileResouceItem/uploadVideo',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}
/**
 *  上传sb3
 *  大小在20MB 以内
 */
export function uploadSb3(formFile){

  return request({
    url: '/api/fileResouceItem/uploadSb3',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}
/**
 *  上传pdf
 *  大小在20MB 以内
 */
export function uploadPdf(formFile){

  return request({
    url: '/api/fileResouceItem/uploadPdf',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}
/**
 *  上传ppt
 *  大小在20MB 以内
 */
export function uploadPpt(formFile){

  return request({
    url: '/api/fileResouceItem/uploadPpt',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}
/**
 *  上传 sprite3
 *  大小在20MB 以内
 */
export function uploadSprite3(formFile){
  return request({
    url: '/api/fileResouceItem/uploadSprite3',
    method: 'POST',
    loading: true,
    files: {
      formFile
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/resouce.js